<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryAllCourseInfo">
    <v-flex md2 align-self-center>
      <v-select
        :label="labels.semester"
        v-model="select_semester"
        :items="semesters"
        :item-text="getSemesterText"
        item-value="Semester"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        :label="labels.college"
        v-model="selectCollege"
        :items="colleges"
        :item-text="collegeText[select_language.lang]"
        item-value="CollegeNo"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        :label="labels.department"
        v-model="selectDepartment"
        :items="departments"
        :item-text="departmentText[select_language.lang]"
        item-value="DeptNo"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        :label="labels.period"
        v-model="selectPeriod"
        :items="periods"
        :item-text="getPeriodText"
        item-value="PeriodCode"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        :label="labels.grade"
        v-model="selectGrade"
        :items="grades"
        :item-text="getGradeText"
        item-value="GradeCode"
      ></v-select>
    </v-flex>
    <v-flex md1>
      <v-btn round block :disabled="btn_state" v-on:click="GetClassSchedule()">
        <v-icon>search</v-icon>
        {{ labels.enter }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
    import languages from "../../languages/TabClassSchedule.json";

    export default {
        data: () => ({
            labels: {
                semester: "",
                college: "",
                department: "",
                period: "",
                grade: "",
                enter: "",
            },
            colleges: [],
            collegeText: { zh: "CollegeName", en: "CollegeEngName" },
            selectCollege: "",
            departments: [],
            departmentText: { zh: "Department", en: "EngDepartment" },
            selectDepartment: "",
            periods: [],
            periodText: { zh: "Period", en: "EngPeriod" },
            selectPeriod: "",
            grades: [],
            selectGrade: "",
        }),
        computed: {
            btn_state() {
                return this.$store.state.btn_state;
            },
            semesters() {
                return this.$store.state.semesters;
            },
            select_semester: {
                get() {
                    return this.$store.state.select_semester;
                },
                set(value) {
                    this.$store.commit("setSelectSemester", value);
                },
            },
            select_language() {
                return this.$store.state.select_language;
            },
        },
        watch: {
            select_language(value) {
                this.setLanguage(value);
            },
            selectCollege(value) {
                fetch("api/departments?collegeNo=" + String(value))
                    .then((response) => response.json())
                    .then((data) => (this.departments = data));
            },
            selectDepartment(value) {
                fetch("api/Period?deptNo=" + String(value))
                    .then((response) => response.json())
                    .then((data) => (this.periods = data));
            },
            selectPeriod() {
                fetch(
                    "api/Grade?eduCode=" +
                    String(this.selectCollege + this.selectPeriod + this.selectDepartment)
                )
                    .then((response) => response.json())
                    .then((data) => (this.grades = data));
            },
        },
        created() {
            this.setLanguage(this.$store.state.select_language);
        },
        mounted() {
            fetch("api/Colleges/")
                .then((response) => response.json())
                .then((data) => (this.colleges = data));
        },
        methods: {
            GetClassSchedule: function () {
                if (
                    this.selectCollege == "" ||
                    this.selectPeriod == "" ||
                    this.selectDepartment == "" ||
                    (this.selectPeriod != "MM" && this.selectGrade == "")
                ) {
                    this.$store.commit("showAlert", "請選擇完整班級");
                } else {
                    var param = {
                        Semester: this.$store.state.select_semester,
                        Language: this.select_language.lang,
                        EduCode: String(
                            this.selectCollege +
                            this.selectPeriod +
                            this.selectDepartment +
                            (this.selectGrade == "" ? "*" : this.selectGrade)
                        ),
                    };
                    this.$store.dispatch("getCourseSchedule", param);
                }
            },
            setLanguage: function (select_language) {
                this.labels.semester = languages.semester[select_language.lang];
                this.labels.college = languages.college[select_language.lang];
                this.labels.department = languages.department[select_language.lang];
                this.labels.period = languages.period[select_language.lang];
                this.labels.grade = languages.grade[select_language.lang];
                this.labels.enter = languages.enter[select_language.lang];
            },
            getPeriodText(item) {
                if (!item) return '';

                return this.select_language.lang === 'en'
                    ? (item.EngPeriod || '')
                    : (item.Period || '');
            },
            getGradeText(item) {
                if (!item) return '';

                return this.select_language.lang === 'en'
                    ? (item.EngGrade || '')
                    : (item.Grade || '');
            },
            getSemesterText(item) {
                if (!item) return '';
                return this.select_language.lang === 'en'
                    ? item.EngSemester
                    : item.Semester;
            }
        },
    };
</script>
